import { EpiLink } from '@api/types';

export const getInternalPath = (urlString: string) => {
  try {
    const url = new URL(urlString);
    return url.pathname + url.search;
  } catch {
    return urlString;
  }
};

export const getLinkGuid = (link: EpiLink) => {
  return link.contentLink?.guidValue;
};

export const isExternalLink = (url?: string) => {
  if (!url) {
    return false;
  }
  const tmp = document.createElement('a');
  tmp.href = url;
  return tmp.host !== window.location.host;
};

/**
 * Get link display data from EPI LinkItem type
 */
export const getLinkData = ({ contentLink, title, href }: EpiLink) => {
  let isInternal,
    path = '',
    target = '';

  // Case: ContentLink from EPI exists
  if (contentLink) {
    isInternal = true;
    path = getInternalPath(href || '') ?? '';
  }
  // Case: href exists and is not external
  else if (href && !isExternalLink(href)) {
    isInternal = true;
    path = getInternalPath(href) || '';
  }

  return { isInternal, href, path, title, target };
};

export const isActivePath = (path?: string): boolean => {
  if (!path) {
    return false;
  }
  return window.location.pathname === path;
};
